import React, { useEffect, useState } from 'react';
import { Shield, CreditCard, Leaf, Check, Package, Gift, ChevronDown, HeartPulse, ListChecks, Flame, AlertTriangle } from 'lucide-react';
import { trackAddToCart } from '../utils/pixel';
const bonuses = [{
  number: 1,
  name: 'Botiquín Natural SOS',
  subtitle: 'Gases · Gripa · Congestión · Garganta',
  image: 'https://cdn.magicpatterns.com/uploads/eidfksRvTvmbR7FMiFHWfR/bonus_1_col.png',
  bullets: ['SOS Gases e Hinchazón — infusión carminativa + calor local (15–20 min)', 'SOS Inicio de Gripa — bebida tibia + hidratación estratégica (24h)', 'SOS Congestión Nasal — vapor + postura + ambiente (5–10 min)', 'SOS Dolor de Garganta — gárgaras + bebida suave (alivio inmediato)', 'Tabla síntoma-a-síntoma para no confundirte', 'Checklist de señales de alarma'],
  quote: 'La diferencia entre improvisar y actuar con un plan.'
}, {
  number: 2,
  name: 'Lista de Compras + Sustituciones',
  subtitle: 'Tu alacena lista para aplicar La Medicina Natural',
  image: 'https://cdn.magicpatterns.com/uploads/3tbpQGWBkdLU7QErHtyWjJ/bonus_2_col.png',
  bullets: ['Capa BASE — lo que más vas a usar (lo primero que compras)', 'Capa ACTIVADORES — lo que multiplica la absorción', 'Capa ESCUDOS — lo que protege mientras sanas', 'Tabla de sustituciones 1:1 — Si no hay hinojo, usa anís.', 'Versión económica vs premium — presupuesto real', 'Tracker de 7 días — energía, claridad, sueño y digestión'],
  quote: 'Compra inteligente en 1 visita. Sin adivinar. Sin frustrarte.'
}, {
  number: 3,
  name: 'Guía Anti-Error: Dosis y Seguridad',
  subtitle: 'Aplica La Medicina Natural con confianza (sin pánico)',
  image: 'https://cdn.magicpatterns.com/uploads/jzCF96rkSa3stacgV5d2Lz/bonus_3_col.png',
  bullets: ['Tabla de medidas reales de cocina — 1 cdta = 5ml. Sin adivinar.', 'Infusión vs Decocción vs Maceración — cuándo usar cada una', 'Tiempos exactos — 7–12 min tapada para infusión.', 'Los 7 errores que arruinan resultados — evítalos', 'Checklist de seguridad en 30 segundos', 'Plantilla para hablar con tu médico — sin confrontación'],
  quote: "La diferencia entre 'no me funcionó' y 'wow, sí se siente' casi siempre es cómo lo preparaste."
}];
interface OfferSectionProps {
  id?: string;
  showUrgency?: boolean;
  showCountdown?: boolean;
  showGuarantee?: boolean;
  showPayment?: boolean;
  ctaText?: string;
}
export function OfferSection({
  id,
  showUrgency = true,
  showCountdown = false,
  showGuarantee = true,
  showPayment = true,
  ctaText = '🛒 RECLAMAR MI 80% DE DESCUENTO →'
}: OfferSectionProps) {
  const [viewers, setViewers] = useState(87);
  const [openBonus, setOpenBonus] = useState<number | null>(null);
  useEffect(() => {
    if (showUrgency) {
      const viewerInterval = setInterval(() => {
        setViewers(prev => prev + Math.floor(Math.random() * 3) - 1);
      }, 4000);
      return () => clearInterval(viewerInterval);
    }
  }, [showUrgency]);
  return <section id={id} className="py-12 px-4 max-w-[600px] mx-auto text-center relative" data-id="element-482">
      <div className="relative z-10" data-id="element-483">
        <div className="mb-6 relative rounded-xl overflow-hidden shadow-green-medium border border-[#E8DFD0] bg-white p-2" data-id="element-484">
          <img src="https://cdn.magicpatterns.com/uploads/wNkgHnuwp1k5XF5JLhWa17/ChatGPT_Image_22_feb_2026,_10_16_22_p.m..png" alt="La Medicina Natural + 3 Bonos" className="w-full h-auto block rounded-lg" data-id="element-485" />
        </div>

        {/* Value Stack */}
        <div className="bg-white rounded-2xl p-6 mb-6 border border-[#2D5A3D] shadow-green-soft relative overflow-hidden" data-id="element-486">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2D5A3D] to-[#4A8C5C]" data-id="element-487"></div>

          <div className="space-y-3 mb-6 text-left text-sm border-b border-[#E8DFD0] pb-6" data-id="element-488">
            <div className="flex justify-between items-center" data-id="element-489">
              <span className="text-[#2C1810] font-medium flex items-center gap-2" data-id="element-490">
                <Leaf className="w-4 h-4 text-[#2D5A3D]" data-id="element-491" /> La Medicina Natural
                — Manual Digital
              </span>
              <span className="text-[#5C4A3A] line-through" data-id="element-492">$149.00</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-493">
              <span className="text-[#2C1810] font-medium flex items-center gap-2" data-id="element-494">
                <Leaf className="w-4 h-4 text-[#2D5A3D]" data-id="element-495" /> Acceso Inmediato +
                Actualizaciones
              </span>
              <span className="text-[#2D5A3D] font-bold" data-id="element-496">INCLUIDO</span>
            </div>

            {/* Bonuses expandable */}
            <div className="mt-4 pt-4 border-t border-dashed border-[#E8DFD0] space-y-3" data-id="element-497">
              <p className="text-[#C17817] font-bold text-xs uppercase tracking-widest flex items-center gap-1.5" data-id="element-498">
                <Gift className="w-3.5 h-3.5" data-id="element-499" /> 3 Bonos incluidos hoy
              </p>

              {bonuses.map(bonus => <div key={bonus.number} className="border border-[#E8DFD0] rounded-xl overflow-hidden" data-id="element-500">
                  {/* Bonus header row */}
                  <div className="flex items-center gap-2 p-2.5" data-id="element-501">
                    <img src={bonus.image} alt={bonus.name} className="w-10 h-10 rounded-lg object-cover shrink-0 shadow-sm" data-id="element-502" />
                    <div className="flex-1 min-w-0" data-id="element-503">
                      <p className="text-[#2C1810] font-bold text-xs leading-tight truncate" data-id="element-504">
                        Bono #{bonus.number} — {bonus.name}
                      </p>
                      <p className="text-[#8B7355] text-[10px] truncate" data-id="element-505">
                        {bonus.subtitle}
                      </p>
                    </div>
                    <div className="flex items-center gap-1.5 shrink-0" data-id="element-506">
                      <span className="text-[#5C4A3A] line-through text-[10px]" data-id="element-507">
                        $47
                      </span>
                      <span className="bg-[#2D5A3D] text-white text-[10px] font-bold px-1.5 py-0.5 rounded" data-id="element-508">
                        GRATIS
                      </span>
                    </div>
                  </div>

                  {/* Read more button */}
                  <button onClick={() => setOpenBonus(openBonus === bonus.number ? null : bonus.number)} className="w-full flex items-center justify-center gap-1 py-1.5 bg-[#F0F4EC] border-t border-[#E8DFD0] text-[#2D5A3D] text-[11px] font-bold hover:bg-[#E8F0E4] transition-colors" data-id="element-509">
                    {openBonus === bonus.number ? 'Ocultar' : 'Leer más'}
                    <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${openBonus === bonus.number ? 'rotate-180' : ''}`} data-id="element-510" />
                  </button>

                  {/* Expanded content */}
                  {openBonus === bonus.number && <div className="p-3 bg-[#FEFCF6] border-t border-[#E8DFD0]" data-id="element-511">
                      <ul className="space-y-1.5 mb-3" data-id="element-512">
                        {bonus.bullets.map((bullet, j) => <li key={j} className="flex items-start gap-2 text-[11px] text-[#2C1810]" data-id="element-513">
                            <Check className="w-3 h-3 text-[#2D5A3D] mt-0.5 shrink-0" data-id="element-514" />
                            <span data-id="element-515">{bullet}</span>
                          </li>)}
                      </ul>
                      <p className="text-[#2D5A3D] text-[11px] italic font-medium border-l-2 border-[#2D5A3D] pl-2" data-id="element-516">
                        "{bonus.quote}"
                      </p>
                    </div>}
                </div>)}
            </div>
          </div>

          <div className="flex flex-col items-center gap-1 leading-none mb-6" data-id="element-517">
            <div className="text-sm text-[#5C4A3A] font-medium mb-1" data-id="element-518">
              VALOR REAL: <span className="line-through" data-id="element-519">$290.00</span>
            </div>
            <div className="font-serif font-bold text-[48px] text-[#2D5A3D] tracking-tight mt-2" data-id="element-520">
              $6.97
            </div>
            <div className="text-xs text-[#8B7355] font-medium" data-id="element-521">
              Descarga digital instantánea
            </div>
            <div className="bg-[#B91C1C] text-white px-4 py-1 rounded-full font-bold text-[12px] uppercase mt-3 animate-pulse flex items-center gap-1.5" data-id="element-522">
              <Flame className="w-3 h-3" data-id="element-523" /> Ahorras 95% Hoy
            </div>
          </div>

          <div className="flex justify-center gap-4 pt-6 border-t border-[#E8DFD0] text-[#5C4A3A] text-xs font-bold" data-id="element-524">
            <div className="flex items-center gap-1.5" data-id="element-525">
              <Shield className="w-4 h-4 text-[#2D5A3D]" data-id="element-526" /> Garantía 7 Días
            </div>
            <div className="flex items-center gap-1.5" data-id="element-527">
              <CreditCard className="w-4 h-4 text-[#2D5A3D]" data-id="element-528" /> Pago Seguro
            </div>
          </div>
        </div>

        {showUrgency && <div className="flex flex-col gap-3 mb-6" data-id="element-529">
            <div className="bg-[#F0F4EC] text-[#2D5A3D] text-sm p-3 rounded-lg border border-[#2D5A3D]/20 flex items-center justify-center gap-2" data-id="element-530">
              <span className="w-2 h-2 bg-[#166534] rounded-full animate-pulse" data-id="element-531"></span>
              <strong data-id="element-532">{viewers} personas</strong> ven esta página ahora mismo
            </div>
            <div className="text-xs text-[#B91C1C] font-bold flex items-center justify-center gap-1.5" data-id="element-533">
              <AlertTriangle className="w-3.5 h-3.5" data-id="element-534" /> El precio de $6.97 es
              por tiempo limitado
            </div>
          </div>}

        <a href="https://pay.hotmart.com/D104591124J?off=pf8xmxms" onClick={() => trackAddToCart()} className="block w-full bg-[#B91C1C] hover:bg-[#991B1B] text-white font-bold py-4 px-6 rounded-xl text-base uppercase tracking-wide shadow-[0_4px_14px_0_rgba(185,28,28,0.4)] hover:-translate-y-1 transition-all duration-300" data-id="element-535">
          SÍ — QUIERO EL MANUAL + LOS 3 BONOS GRATIS
        </a>

        {showPayment && <div className="flex flex-col items-center gap-2 text-center" data-id="element-536">
            <div className="flex items-center justify-center gap-2 text-xs text-[#5C4A3A]" data-id="element-537">
              <Shield className="w-3 h-3 text-[#2D5A3D]" data-id="element-538" /> Garantía 7 Días
            </div>
            <div className="flex gap-3 opacity-70 grayscale hover:grayscale-0 transition-all" data-id="element-539">
              {['VISA', 'MC', 'AMEX', 'PAYPAL'].map(card => <span key={card} className="text-[10px] border border-[#E8DFD0] px-2 py-1 rounded text-[#5C4A3A] font-bold bg-white" data-id="element-540">
                  {card}
                </span>)}
            </div>
          </div>}
      </div>
    </section>;
}